import { render } from "./WalletAddress.vue?vue&type=template&id=a843671c&ts=true"
import script from "./WalletAddress.vue?vue&type=script&lang=ts"
export * from "./WalletAddress.vue?vue&type=script&lang=ts"

import "./WalletAddress.vue?vue&type=style&index=0&id=a843671c&lang=scss"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/payment/WalletAddress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a843671c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a843671c', __exports__)) {
    api.reload('a843671c', __exports__)
  }
  
  module.hot.accept("./WalletAddress.vue?vue&type=template&id=a843671c&ts=true", () => {
    api.rerender('a843671c', render)
  })

}


export default __exports__